// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33woW","toggle":"styles_toggle__2JQ62","preview":"styles_preview__1-TcK"};